export type ActiveFunctionsTogglesOption = {
  name: string;
  value: string;
};

export type ActiveFunctionsOptions = {
  name: string;
  value: string;
  function: string;
};

export const activeFunctionsOptions: ActiveFunctionsTogglesOption[] = [
  {
    name: 'topics:active-function:adjuvant',
    value: 'adjuvant',
  },
  {
    name: 'topics:active-function:emulsifier',
    value: 'emulsifier',
  },
  {
    name: 'topics:active-function:liquidColorant',
    value: 'liquidColorant',
  },
  {
    name: 'topics:active-function:solvent',
    value: 'solvent',
  },
  {
    name: 'topics:active-function:stabilizer',
    value: 'stabilizer',
  },
];

export const tempEmulsifiers: ActiveFunctionsOptions[] = [
  {
    name: 'Emulsifier 1',
    value: 'emulsifier 1',
    function: 'emulsifier',
  },
  {
    name: 'Emulsifier 2',
    value: 'emulsifier 2',
    function: 'emulsifier',
  },
  {
    name: 'Emulsifier 3',
    value: 'emulsifier 3',
    function: 'emulsifier',
  },
  {
    name: 'Emulsifier 4',
    value: 'emulsifier 4',
    function: 'emulsifier',
  },
];

export const tempStabiliers: ActiveFunctionsOptions[] = [
  {
    name: 'Stabilier 1',
    value: 'stabilier 1',
    function: 'stabilizer',
  },
  {
    name: 'Stabilier 2',
    value: 'stabilier 2',
    function: 'stabilizer',
  },
  {
    name: 'Stabilier 3',
    value: 'stabilier 3',
    function: 'stabilizer',
  },
  {
    name: 'Stabilier 4',
    value: 'stabilier 4',
    function: 'stabilizer',
  },
];

export const tempAdjuvants: ActiveFunctionsOptions[] = [
  {
    name: 'Adjuvants 1',
    value: 'adjuvants 1',
    function: 'adjuvant',
  },
  {
    name: 'Adjuvants 2',
    value: 'adjuvants 2',
    function: 'adjuvant',
  },
  {
    name: 'Adjuvants 3',
    value: 'adjuvants 3',
    function: 'adjuvant',
  },
  {
    name: 'Adjuvants 4',
    value: 'adjuvants 4',
    function: 'adjuvant',
  },
];

export const tempLiquidColorant: ActiveFunctionsOptions[] = [
  {
    name: 'Liquid Colorant 1',
    value: 'liquid colorant 1',
    function: 'liquidColorant',
  },
  {
    name: 'Liquid Colorant 2',
    value: 'liquid colorant 2',
    function: 'liquidColorant',
  },
  {
    name: 'Liquid Colorant 3',
    value: 'liquid colorant 3',
    function: 'liquidColorant',
  },
  {
    name: 'Liquid Colorant 4',
    value: 'liquid colorant 4',
    function: 'liquidColorant',
  },
];

export const tempSolvents: ActiveFunctionsOptions[] = [
  {
    name: 'Solvent 1',
    value: 'solvent 1',
    function: 'solvent',
  },
  {
    name: 'Solvent 2',
    value: 'solvent 2',
    function: 'solvent',
  },
  {
    name: 'Solvent 3',
    value: 'solvent 3',
    function: 'solvent',
  },
  {
    name: 'Solvent 4',
    value: 'solvent 4',
    function: 'solvent',
  },
];
